const state = {
  // Snackbar 佇列（多重訊息可疊加）
  snackbars: [],
  // Dialog（單一，互斥）
  dialog: null,
  // 全域累計 ID（給每個 Snackbar 唯一 key）
  _idCounter: 0,
}

const mutations = {
  pushSnackbar(state, snackbar) {
    state._idCounter += 1
    state.snackbars.push({ id: state._idCounter, ...snackbar })
  },
  removeSnackbar(state, id) {
    state.snackbars = state.snackbars.filter(s => s.id !== id)
  },
  setDialog(state, dialog) {
    state.dialog = dialog
  },
  clearDialog(state) {
    state.dialog = null
  },
}

const actions = {
  // Snackbar 系列：輕量提示，自動消失
  showSuccess({ commit }, payload) {
    const msg = typeof payload === 'string' ? { message: payload } : payload
    commit('pushSnackbar', { type: 'success', color: 'success', timeout: 3000, ...msg })
  },
  showError({ commit }, payload) {
    const msg = typeof payload === 'string' ? { message: payload } : payload
    commit('pushSnackbar', { type: 'error', color: 'error', timeout: 5000, ...msg })
  },
  showWarning({ commit }, payload) {
    const msg = typeof payload === 'string' ? { message: payload } : payload
    commit('pushSnackbar', { type: 'warning', color: 'warning', timeout: 4000, ...msg })
  },
  showInfo({ commit }, payload) {
    const msg = typeof payload === 'string' ? { message: payload } : payload
    commit('pushSnackbar', { type: 'info', color: 'info', timeout: 3000, ...msg })
  },
  // Dialog 系列：需確認的訊息（取代原 globalAlert）
  showAlert({ commit }, payload) {
    const data = typeof payload === 'string' ? { message: payload } : payload
    commit('setDialog', {
      mode: 'alert',
      message: data.message,
      to: data.to || null,
      onConfirm: data.onConfirm || null,
      confirmText: data.confirmText || '確認',
    })
  },
  // Confirm 系列：取代 window.confirm()，回傳 Promise<boolean>
  showConfirm({ commit }, payload) {
    return new Promise((resolve) => {
      const data = typeof payload === 'string' ? { message: payload } : payload
      commit('setDialog', {
        mode: 'confirm',
        message: data.message,
        confirmText: data.confirmText || '確認',
        cancelText: data.cancelText || '取消',
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
      })
    })
  },
}

const getters = {
  snackbars: state => state.snackbars,
  dialog: state => state.dialog,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
